'use client';

import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';
import { cn } from 'ui';

export function DotsBgContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  function handleMouseMove({
    currentTarget,
    clientX,
    clientY,
  }: React.MouseEvent<HTMLDivElement>) {
    if (!currentTarget) return;
    const { left, top } = currentTarget.getBoundingClientRect();

    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }

  const dotPattern = (color: string) => ({
    backgroundImage: `radial-gradient(circle, ${color} 1px, transparent 1px)`,
    backgroundSize: '16px 16px',
  });

  return (
    <div
      className={cn('group relative', className)}
      onMouseMove={handleMouseMove}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={dotPattern('rgb(var(--gray-300))')} // gray-300 for light mode
      />
      <div
        className="pointer-events-none absolute inset-0 opacity-0 dark:opacity-70"
        style={dotPattern('rgb(var(--gray-800))')} // gray-800 for dark mode
      />
      <motion.div
        className="pointer-events-none absolute inset-0 opacity-0 transition duration-300 group-hover:opacity-100"
        style={{
          ...dotPattern('#6172F3'), // indigo-500
          maskImage: useMotionTemplate`
        radial-gradient(
          200px circle at ${mouseX}px ${mouseY}px,
          black 0%,
          transparent 100%
        )
      `,
        }}
      />
      {children}
    </div>
  );
}
